import {setLocaleNumFmtForced} from "./";

export const setLocaleNumFmt = (locale, cell) => {
  if (typeof cell.value === 'number') {
    cell = setLocaleNumFmtForced(locale, cell);
  }
  return cell;
};